package com.macrofocus.eflux.ui

import com.macrofocus.eflux.network.DerivedBranchColumn
import com.macrofocus.eflux.network.DerivedBusColumn
import com.macrofocus.eflux.network.physical.Branch
import com.macrofocus.eflux.network.physical.Bus
import js.objects.unsafeJso
import mui.material.Typography
import mui.material.styles.Theme
import mui.material.styles.useTheme
import mui.system.Box
import org.molap.aggregates.cube.DistributiveStatistics
import org.molap.dataframe.DataFrame
import org.molap.dataframe.rowmajor.RowMajorDataFrame
import org.molap.series.Series
import org.w3c.dom.HTMLDivElement
import react.*
import web.cssom.Auto
import web.cssom.Display
import web.cssom.FlexDirection
import web.cssom.pct

external interface SparklineDataFrameTableProps : Props {
    var pathSelection: Branch?
    var fromDataFrame: DataFrame<Bus, RowMajorDataFrame.Column<Bus, Any?>, Any?>?
    var toDataFrame: DataFrame<Bus, RowMajorDataFrame.Column<Bus, Any?>, Any?>?
    var dataFrame: DataFrame<Branch, RowMajorDataFrame.Column<Branch, Any?>, Any?>?
    var dateTime: Long
}

val SparklineDataFrameTable = FC<SparklineDataFrameTableProps> { props ->
    val theme = useTheme<Theme>()
    val paletteType = if(theme.asDynamic().palette.mode == "dark") PaletteType.dark else PaletteType.light

    val dataFrame = props.dataFrame

//    val (pathSelection, _) = props.pathSelection.toState()
    val pathSelection = props.pathSelection

    val targetRef = useRef<HTMLDivElement>()
    val (getWidth, setWidth) = useState(180.0) // EFluxGlobals.timeSeriesWidth

    useLayoutEffect {
        if(targetRef.current != null) {
            setWidth(targetRef.current.asDynamic().offsetWidth as Double)
        }
    }

    if (dataFrame != null) {
        Box {
            sx = unsafeJso {
                height = 100.pct
                overflowY = Auto.auto

                display = Display.flex
                flexDirection = FlexDirection.column
            }

            props.fromDataFrame?.let {
                val dateTime = it.getColumn(DerivedBusColumn.datetime) as Series<Any?, *>
                val dateTimeStatistics = DistributiveStatistics(dateTime)
                println("Stat: ${dateTimeStatistics.minimum}-${dateTimeStatistics.maximum}")

                for (column in DerivedBusColumn.timeseries) {
                    BusSparklineColumn {
                        this.bus = pathSelection?.from
                        this.getWidth = getWidth
                        this.dataFrame = it
                        this.dateTime = dateTime
                        this.dateTimeStatistics = dateTimeStatistics
                        this.paletteType = paletteType
                        this.column = column
                        this.masterDateTime = props.dateTime
                    }
                }
            }

            dataFrame.let {
                val dateTime = it.getColumn(DerivedBranchColumn.datetime) as Series<Any?, *>
                val dateTimeStatistics = DistributiveStatistics(dateTime)
                println("Stat: ${dateTimeStatistics.minimum}-${dateTimeStatistics.maximum}")

                for (column in DerivedBranchColumn.timeseries) {
                    BranchSparklineColumn {
                        this.branch = pathSelection
                        this.getWidth = getWidth
                        this.dataFrame = it
                        this.dateTime = dateTime
                        this.dateTimeStatistics = dateTimeStatistics
                        this.paletteType = paletteType
                        this.props = props
                        this.column = column
                    }
                }
            }

            props.toDataFrame?.let {
                val dateTime = it.getColumn(DerivedBusColumn.datetime) as Series<Any?, *>
                val dateTimeStatistics = DistributiveStatistics(dateTime)
                println("Stat: ${dateTimeStatistics.minimum}-${dateTimeStatistics.maximum}")

                for (column in DerivedBusColumn.timeseries) {
                    BusSparklineColumn {
                        this.bus = pathSelection?.to
                        this.getWidth = getWidth
                        this.dataFrame = it
                        this.dateTime = dateTime
                        this.dateTimeStatistics = dateTimeStatistics
                        this.paletteType = paletteType
                        this.column = column
                        this.masterDateTime = props.dateTime
                    }
                }
            }
        }
    } else {
        Typography {
            +""
        }
    }
}

